module.exports = __webpack_public_path__ + "assets/9f1c83dfb0a6af819039403aa315c810.png";